import {ForgotPasswordSendTokenParams} from 'domain/usecases';
import {makeForgotPasswordSendToken} from 'main/factories/usecases';

export async function sendForgotPasswordToken({
	signal,
	...tokenParams
}: ForgotPasswordSendTokenParams) {
	const response = await makeForgotPasswordSendToken().sendToken({signal, ...tokenParams});

	return response;
}
